module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_8011.1c27bd3c.png";